import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./updateBundle.css";
import logoBlue from "../../components/images/logoblue.png";
import { Delete, Edit, Check, Sync, ArrowBack } from "@material-ui/icons";
import { updateBundle } from "../../services/subscriptions.services.js";

const initialState = {
  title: "",
  features: [
    {
      name: "Clock only",
      description: "Use our clock only version",
      available: true,
    },
  ],
  price: 0,
  priceUnit: "dollar",
  androidProductId: null,
  iosProductId: null,
  type: "",
  displayOrder: 0,
  numberOfUsage: 0,
};

export default function UpdateBundle(props) {
  const [visible, setVisible] = useState(false);

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [selectedFeature, setSelectedFeature] = useState("");

  const [features, setFeatures] = useState([
    {
      name: "",
      description: "",
      available: true,
    },
  ]);

  const handleFormChange = (name, value) => {
    if (name === "selectedFeature") {
      setSelectedFeature(value);
    } else {
      setInitialStateForm((prevState) => ({
        ...prevState,
        [name]:
          name === "price" ||
          name === "displayOrder" ||
          name === "numberOfUsage"
            ? parseInt(value) || 0
            : value,
      }));
    }
  };

  const handleAddFeature = (e) => {
    e.preventDefault();
    setFeatures((prevFeatures) => [
      ...prevFeatures,
      {
        name: "",
        description: "",
        available: true,
      },
    ]);
  };

  const handleFeatureChange = (index, key, value) => {
    setFeatures((prevFeatures) => {
      const newFeatures = [...prevFeatures];
      newFeatures[index][key] = value;
      return newFeatures;
    });
  };
  

  const handleCreate = async (e) => {
    e.preventDefault();
    console.log("created Bundle data", initialStateForm, features);
  
    try {
      setLoading(true);
      const response = await updateBundle(
        {
          ...initialStateForm,
          features: features, // Ensure this is the updated features array
          selectedFeature: selectedFeature,
        },
        JSON.parse(sessionStorage.getItem("myData"))
      );
      // Handle the response as needed
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };
  

  let history = useHistory();

  return (
    <div className="addRule">
      <div className="addRuleHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="addRuleTitle">Add New Subscription Bundle</h1>
        </div>
        <img
          className="addRuleLogo"
          src={logoBlue}
          alt="logo"
          width="150px"
        ></img>
      </div>

      <form className="addRuleForm">
        <div className="ruleNameCodeBox">
          <div className="addRuleItem">
            <input
              type="text"
              placeholder="Bundle Name"
              value={initialStateForm.title}
              onChange={(e) => handleFormChange("title", e.target.value)}
            />
          </div>
          <div className="addRuleItem">
            <input
              type="number"
              placeholder="Bundle Price"
              value={initialStateForm.price}
              onChange={(e) =>
                handleFormChange("price", parseInt(e.target.value))
              }
            />
            USD
          </div>
        </div>

        {features.map((feature, index) => (
        <div key={index}>
          <input
            type="text"
            placeholder="Feature Name"
            value={feature.name}
            onChange={(e) => handleFeatureChange(index, "name", e.target.value)}
          />
          <input
            type="text"
            placeholder="Feature Description"
            value={feature.description}
            onChange={(e) => handleFeatureChange(index, "description", e.target.value)}
          />
          <label>
            Available:
            <input
              type="checkbox"
              checked={feature.available}
              onChange={(e) => handleFeatureChange(index, "available", e.target.checked)}
            />
          </label>
          {/* Add more fields as needed */}
        </div>
      ))}

      <button onClick={(e) => handleAddFeature(e)}>Add Feature</button>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Android Product Id :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange("androidProductId", e.target.value)
            }
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">iOS Product Id :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) => handleFormChange("iosProductId", e.target.value)}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Type :</h4>
          <input
            className="input"
            type="text"
            onChange={(e) => handleFormChange("type", e.target.value)}
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Display Order :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange("displayOrder", parseInt(e.target.value))
            }
          />
        </div>

        <div className="addRuleView">
          <h4 className="addRuleTxt">Number Of Usage :</h4>
          <input
            className="input"
            type="number"
            onChange={(e) =>
              handleFormChange("numberOfUsage", parseInt(e.target.value))
            }
          />
        </div>

        <button className="addRuleButton" onClick={handleCreate}>
          Create
        </button>
      </form>
    </div>
  );
}
